import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const TestimonialSection = () => {
  const testimonials = [
    {
      id: 1,
      name: 'Sarah Chen',
      role: 'Professional Trader',
      avatar: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=64&h=64&fit=crop&crop=face',
      content: `The PTS-WIZARD-V3 algorithm has completely transformed my trading strategy. The precision and customization options are unmatched in the industry.`,
      rating: 5,
      verified: true
    },
    {
      id: 2,
      name: 'Marcus Rodriguez',
      role: 'Crypto Analyst',
      avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=64&h=64&fit=crop&crop=face',
      content: `Real-time data accuracy and the advanced technical analysis tools have given me a significant edge in volatile markets. Highly recommended!`,
      rating: 5,
      verified: true
    },
    {
      id: 3,
      name: 'Emily Watson',
      role: 'Portfolio Manager',
      avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=64&h=64&fit=crop&crop=face',
      content: `Managing multiple portfolios has never been easier. The automated reporting and risk management features save me hours every day.`,
      rating: 5,
      verified: true
    }
  ];

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <Icon
        key={index}
        name="Star"
        size={14}
        color={index < rating ? "var(--color-warning)" : "var(--color-muted-foreground)"}
        className={index < rating ? "fill-current" : ""}
      />
    ));
  };

  return (
    <div className="space-y-6">
      <div className="text-center">
        <h3 className="text-xl font-semibold text-foreground mb-2">
          Trusted by Professionals
        </h3>
        <p className="text-sm text-muted-foreground">
          See what our users say about CryptoWizard Pro
        </p>
      </div>
      <div className="space-y-4">
        {testimonials?.map((testimonial) => (
          <div key={testimonial?.id} className="bg-card border border-border rounded-lg p-4">
            {/* Header */}
            <div className="flex items-start space-x-3 mb-3">
              <Image
                src={testimonial?.avatar}
                alt={testimonial?.name}
                className="w-10 h-10 rounded-full object-cover"
              />
              <div className="flex-1 min-w-0">
                <div className="flex items-center space-x-2">
                  <h4 className="text-sm font-medium text-foreground truncate">
                    {testimonial?.name}
                  </h4>
                  {testimonial?.verified && (
                    <Icon name="BadgeCheck" size={14} color="var(--color-accent)" />
                  )}
                </div>
                <p className="text-xs text-muted-foreground">{testimonial?.role}</p>
              </div>
            </div>

            {/* Rating */}
            <div className="flex items-center space-x-1 mb-3">
              {renderStars(testimonial?.rating)}
            </div>

            {/* Content */}
            <blockquote className="text-sm text-foreground leading-relaxed">
              "{testimonial?.content}"
            </blockquote>
          </div>
        ))}
      </div>
      {/* Stats */}
      <div className="grid grid-cols-3 gap-4 pt-4 border-t border-border">
        <div className="text-center">
          <div className="text-lg font-semibold text-foreground">50K+</div>
          <div className="text-xs text-muted-foreground">Active Users</div>
        </div>
        <div className="text-center">
          <div className="text-lg font-semibold text-foreground">$2.5B+</div>
          <div className="text-xs text-muted-foreground">Volume Traded</div>
        </div>
        <div className="text-center">
          <div className="text-lg font-semibold text-foreground">99.9%</div>
          <div className="text-xs text-muted-foreground">Uptime</div>
        </div>
      </div>
      {/* Call to Action */}
      <div className="bg-primary/5 border border-primary/20 rounded-lg p-4 text-center">
        <Icon name="Users" size={24} color="var(--color-primary)" className="mx-auto mb-2" />
        <h4 className="text-sm font-medium text-foreground mb-1">
          Join the Community
        </h4>
        <p className="text-xs text-muted-foreground">
          Connect with thousands of traders sharing strategies and insights
        </p>
      </div>
    </div>
  );
};

export default TestimonialSection;